import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
import Form, { Validations } from '../../../../../components/Form';
import { ControlItem } from '../../../types';
import { formatParam } from '../../helpers';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const CreateBotForm = () => {
  const [baseAsset, setBaseAsset] = useState<string | undefined>();
  const [quoteAsset, setQuoteAsset] = useState<string>('USDT');
  const [shouldStart, setShouldStart] = useState('false');

  const [errors, setErrors] = useState<Record<string, Validations>>({});
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const checkValidation = useCallback(() => {
    /** userId can not be empty */

    setErrors({});

    /** @TODO grts-control needs to double check if pair exists */
    if (typeof baseAsset === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        baseAsset: Validations.Required,
      }));
    }

    if (typeof quoteAsset === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        quoteAsset: Validations.Required,
      }));
    }

    // if (typeof stableBalance !== 'undefined' && stableBalance?.length !== 0) {
    //   const number = parseFloat(stableBalance);

    //   if (isNaN(number)) {
    //     setErrors((prev) => ({
    //       ...prev,
    //       stableBalance: Validations.NumberTyping,
    //     }));
    //   }
    // }

    // if (typeof assetBalance !== 'undefined' && assetBalance?.length !== 0) {
    //   const number = parseFloat(assetBalance);

    //   if (isNaN(number)) {
    //     setErrors((prev) => ({
    //       ...prev,
    //       assetBalance: Validations.NumberTyping,
    //     }));
    //   }
    // }

    if (shouldStart !== 'true' && shouldStart !== 'false') {
      setErrors((prev) => ({
        ...prev,
        multiOrderTimeframe: Validations.BooleanTyping,
      }));
    }

    return true;
  }, [baseAsset, quoteAsset, shouldStart]);

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);
    const canContinue = checkValidation();

    if (!canContinue) {
      return;
    }

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.AddBot,
      params: {
        baseAsset: formatParam(baseAsset),
        quoteAsset: formatParam(quoteAsset),
        shouldStart: formatParam(shouldStart),
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [baseAsset, checkValidation, quoteAsset, shouldStart]);

  const config = useMemo(() => {
    return {
      title: ControlItem.CreateBot,
      formMessage,
      fields: [
        {
          label: 'Base Asset',
          value: baseAsset,
          handleValueChange: setBaseAsset,
          error: errors.baseAsset,
        },
        {
          label: 'Quote Asset',
          value: quoteAsset,
          handleValueChange: setQuoteAsset,
          error: errors.quoteAsset,
        },
        {
          label: 'Should start immediately',
          value: shouldStart,
          handleValueChange: setShouldStart,
          error: errors.shouldStart,
          title: 'Extra',
        },
        // {
        //   label: 'Stable Balance',
        //   value: stableBalance,
        //   handleValueChange: setStableBalance,
        //   error: errors.startStableBalance,
        // },
        // {
        //   label: 'Asset Balance',
        //   value: assetBalance,
        //   handleValueChange: setAssetBalance,
        //   error: errors.currentAssetBalance,
        // },
      ],
      handleSubmit,
      isLoading,
    };
  }, [
    baseAsset,
    errors.baseAsset,
    errors.quoteAsset,
    errors.shouldStart,
    formMessage,
    handleSubmit,
    isLoading,
    quoteAsset,
    shouldStart,
  ]);

  return <Form config={config} />;
};

export default CreateBotForm;
